import { useAuth as e } from "../../hooks/useAuth.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/queries/permissions/useUserPermissionsQuery.ts
var r = (r) => {
	let { activeWorkspaceId: i } = e();
	return t({
		queryKey: [
			"permissions",
			"member",
			i,
			r
		],
		queryFn: () => n.getUserPermissions(r),
		enabled: !!i && !!r,
		staleTime: 60 * 1e3
	});
};
//#endregion
export { r as useUserPermissionsQuery };
